// src/components/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getTokenToLocalStorage } from "@/utils/token";
import { getUserPermissions } from "@/components/business/RolePermission";
import { Message } from "@arco-design/web-react";
import { coming_soon_icon } from "@/assets/user-center";
import { Permissions } from "@/components/business/RolePermission/permissions";
const RedirectRoute = ({ children }) => {
  const token = getTokenToLocalStorage();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const next = searchParams.get("next") || "";
  const routerPermissions = [
    {
      path: "/",
      exempt: true,
    },
    {
      title: "登录",
      path: "/login",
      exempt: true,
    },
    {
      title: "工作台",
      path: "/work-bench",
      exempt: true,
    },
    {
      title: "创作空间",
      path: "/creative-space",
      permissions: Permissions.CreativeSpace,
    },
    {
      subTitle: "爆款脚本",
      path: "/creative-script",
      permissions: Permissions.HotScript,
    },
    {
      subTitle: "创建脚本",
      path: "/creation-script",
      exempt: true,
    },
    {
      subTitle: "AI主题创作",
      path: "/ai-creation",
      permissions: Permissions.AIThemeCreation,
    },
    {
      subTitle: "AI视频解析",
      path: "/analysis-video",
      permissions: Permissions.AIVideoAnalysis,
    },
    {
      subTitle: "智能魔剪",
      path: "/video-clips",
      permissions: Permissions.IntelligentEditing,
    },
    {
      subTitle: "一键成片",
      path: "/accomplish",
      nothingness: true,
    },
    {
      subTitle: "图文创作",
      path: "/image-text",
      nothingness: true,
    },
    {
      subTitle: "团队概览",
      path: "/team-overview",
      permissions: Permissions.TeamManagement,
    },
    {
      subTitle: "团队成员",
      path: "/team-anagement",
      permissions: Permissions.TeamManagement,
    },

    // {
    //   title: "矩阵营销",
    //   path: `/matrix`,
    //   permissions: Permissions.MatrixMarketing,
    //   // nothingness: true,
    // },
    {
      title: "任务中心",
      path: "/task-center",
      permissions: Permissions.TaskCenter,
    },
    {
      title: "个人中心",
      path: "/user",
      permissions: Permissions.UserCenter,
    },
    {
      path: "/ai-creation",
      exempt: true,
    },
    {
      path: "/creative-space/recycling-station",
      exempt: true,
    },
    {
      path: "/aithemecreationtable",
      exempt: true,
    },
    {
      path: "/aithemescriptcreate",
      exempt: true,
    },
    {
      path: "/creation-script/:id",
      exempt: true,
    },
    {
      path: "/team-anagement",
      exempt: true,
    },
    {
      path: "/team-overview",
      exempt: true,
    },
    {
      path: "/analysis-video",
      exempt: true,
    },
    {
      path: "/analysis-video/:id",
      exempt: true,
    },
    {
      path: "/mix-detail/:id/:script_id",
      exempt: true,
    },
    {
      path: "/mixcutDetail/:id",
      exempt: true,
    },
    {
      path: "/video-clip-result/:projectId/:count",
      exempt: true,
    },
    {
      path: "/invite",
      exempt: true,
    },
    {
      path: "/video-editing",
      exempt: true,
    },
  ];
  const isRouter = () => {
    return routerPermissions.find((v) => {
      const regex = new RegExp(`^${v.path.replace(/:\w+/g, "\\w+")}$`, "i");
      return regex.test(location.pathname);
    });
  };

  if (token && !next) {
    if (location.pathname != "/work-bench") {
      if (!isRouter()?.permissions) {
        return children;
      }
      const hasPermission = getUserPermissions(isRouter().permissions);

      if (!hasPermission && !isRouter().exempt) {
        Message.warning("您没有权限");
        return <Navigate to={`/work-bench`} />;
      }
      if (isRouter().nothingness) {
        Message.info({
          icon: <img width={26} src={coming_soon_icon} />,
          content: "敬请期待呦~",
        });
        return <Navigate to={`/work-bench`} />;
      }
    }
  }

  // 如果有token，渲染子组件
  return children;
};

export default RedirectRoute;
